exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-box[data-v-30465c12]{display:flex;flex-direction:row;position:relative;padding:5px;height:34px}.cell-box[data-v-30465c12]:hover,.focus-cell-box[data-v-30465c12]{border:1px dashed #909399;background-color:#fff}.edit-cell[data-v-30465c12]{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-30465c12","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TableCellBox/TableCellBox.vue
// module id = 122
// module chunks = 0